import { render, staticRenderFns } from "./CreateAgreementTemplatePopUp.vue?vue&type=template&id=beadec06&scoped=true"
import script from "./CreateAgreementTemplatePopUp.vue?vue&type=script&lang=js"
export * from "./CreateAgreementTemplatePopUp.vue?vue&type=script&lang=js"
import style0 from "./CreateAgreementTemplatePopUp.vue?vue&type=style&index=0&id=beadec06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beadec06",
  null
  
)

export default component.exports